import { useState, useEffect, useCallback } from 'react';
import { MessageCircle } from 'lucide-react';

const CRISP_ID = '906517c4-3f3b-4d28-b9cd-1d852fb3feb0';

export default function LazyCrisp() {
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  // Listen for Crisp "chat:opened" / "chat:closed" to sync the button state
  useEffect(() => {
    if (!loaded) return;
    window.$crisp = window.$crisp || [];
    window.$crisp.push(['on', 'chat:opened', () => setOpen(true)]);
    window.$crisp.push(['on', 'chat:closed', () => setOpen(false)]);
  }, [loaded]);

  const loadCrisp = useCallback(() => {
    if (loaded) return;
    // Initialize the queue immediately so any push() calls work
    window.$crisp = window.$crisp || [];

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    script.onload = () => {
      setLoaded(true);
      // Open the chat once Crisp is ready
      window.$crisp.push(['do', 'chat:open']);
      setOpen(true);
    };
    document.head.appendChild(script);
  }, [loaded]);

  return (
    <button
      onClick={loadCrisp}
      className="fixed bottom-4 right-4 z-50 w-14 h-14 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg flex items-center justify-center transition-all hover:scale-110 active:scale-95"
      aria-label="Open live chat"
    >
      <MessageCircle className="w-6 h-6" />
      {/* Subtle pulse animation to draw attention */}
      <span className="absolute inset-0 rounded-full bg-blue-400 animate-ping opacity-20" />
    </button>
  );
}